/** @format */

export enum INVENTORY_TYPE {
	ATS,
	ISA,
	BOTH,
	NONE
}
